import MixpanelTrack from "../models/MixpanelTrack";

const MixpanelStore = MixpanelTrack.create();

export default MixpanelStore;
